import React, { useState, useEffect } from 'react';
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable';
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { getResponseErrorMessage } from '@/utils/api-service'

import SeriesOrderItem from '@/components/series/SeriesOrderItem';

import api from '@/api/index'

import './styles/sort-order-series.scss';

interface Props {
  season: string | number
}

function SortOrderSeries({season}: Props) {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true)

  const { id } = useParams();

  const navigate = useNavigate();

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      setItems((items) => {
        const oldIndex = items.findIndex(item => item.id === active.id);
        const newIndex = items.findIndex(item => item.id === over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  const onSave = async() => {
    try {
      setIsLoading(true);

      const ids = items.map((item) => item.id)      
      await api.serie.saveOrder(id,season, ids);

      notification.success({
        message: 'Порядок успешно сохранен'
      });

    } catch (err) {
      console.error(err)

      const messageFormatter = getResponseErrorMessage(err, 'Ошибка при сохранении')

      notification.error({
        message: messageFormatter
      });

    } finally {
      setIsLoading(false);
    }
  }

  const onCancel = () => {
    navigate('/serial');
  }

  const fetchSeries = async () => {
    setIsLoading(true)
    const response = await api.season.getEpisodes(id, season);

    setItems(response.data.data.episodes || []);
    setIsLoading(false)
  }

  useEffect(() => {
    fetchSeries()
  }, [])

  if (isLoading) {
    return (
      <div className="film-view__loader">
        <Spin size="large" indicator={<LoadingOutlined />} />
      </div>
    )
  }

  return (
    <div className='sort-order-series'>
      <div className="sort-order-series__list">
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext items={items.map(item => item.id)}>
            {items.map((item, index) => (
              <SeriesOrderItem
                key={item.id}
                id={item.id}
                text={item.title}
                index={index}
                order={item.sort_order}
                item={item}
              />
            ))}
          </SortableContext>
        </DndContext>
      </div>

      <div className='sort-order-series__footer app-footer'>
        <button className="app-btn secondary" onClick={onCancel}>
          Отмена
        </button>
        <button className="app-btn" onClick={onSave}>
          Сохранить
        </button>
      </div>
    </div>
  );
}

export default SortOrderSeries;